import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import {ButtonContained, ButtonOutlined} from '../components/app-button/button'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import { LogoGa } from '../components/app-icon/Icons'
import Wrapper from '../components/wrapper'
import AppBarInner from '../components/app-bar/AppBarInner'
import SiteBox from '../components/site-box/'
import Loader from '../components/app-loader/'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
    marginTop: 52,
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '0 40px 30px 22px',
  },

  GaIcon: {
    margin: '0 11px 0 17px',
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class GAAsync extends Component {
  state = {
    activeStep: 2,
    site: window.state.site,
    webProperty: window.state.google_analytics_settings.webProperty,
    view: window.state.google_analytics_settings.view,
    isFetching: true,
    hasStatistics: false,
    isCard: window.state.cardTest,
  }

  componentDidMount() {
    const url = '/wizard/sources/sync'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: {},
    })
      .then(status)
      .then(json)
      .then(({ status, nextUrl, hasStatistics }) => {
        if (status === 'ok') {
          this.setState({
            isFetching: false,
            nextUrl,
          })
          if (hasStatistics) {
            this.setState({
              hasStatistics,
            })
          }
        }
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  render() {
    const { classes } = this.props
    const {
      site,
      webProperty,
      view,
      nextUrl,
      isFetching,
      hasStatistics,
      isCard,
    } = this.state

    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    const loader = isFetching ? <Loader /> : null

    const fetchingDataMesssage = isFetching
      ? 'Получаем данные из Google Analytics.'
      : undefined

    const getDataMesssage =
      !isFetching && hasStatistics
        ? 'Данные из Google Analytics получены'
        : !isFetching && !hasStatistics
        ? 'Данные не получены.'
        : undefined

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <div style={{width: 200, position: 'relative'}}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
            <a
              href="/wizard/ga/confirm"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} text="Назад"/>
            </a>
          </div>
          <div className={classes.wizardContent}>
            <SiteBox
              url={site.url}
              resource={site.name}
              gutterBottom={8}
              prevUrl={'/wizard/site'}
            />

            <SiteBox
              icon={<LogoGa className={classes.GaIcon} />}
              url={`${webProperty.name} (${webProperty.id})`}
              resource={view.name}
              gutterBottom={24}
              prevUrl={'/wizard/ga/settings'}
            />

            <Wrapper shadow={4}>
              <header className={classes.header}>
                <Typography variant="body1">
                  {fetchingDataMesssage}
                  {getDataMesssage}
                </Typography>
              </header>

              {loader}

              <section className={classes.content}>
                <Typography variant="body1" component="div">
                  {isFetching ? (
                    <Fragment>
                      <div>Подождите немного.</div>
                      <div>Обычно это занимает не более минуты.</div>
                    </Fragment>
                  ) : null}
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{ marginBottom: 16, marginTop: 32 }}
                >
                  Для вашего удобства, мы получаем статистику переходов из
                  вашего Google Analytics, и даем вам возможность указывать
                  расходы по каждой комбинации utm-меток.
                </Typography>
                <Typography variant="subtitle1" style={{ marginBottom: 16 }}>
                  Для ряда рекламных сервисов вы можете подключить
                  автоматический импорт раходов.
                </Typography>
                <Typography variant="subtitle1">
                  {isFetching
                    ? `По тем каналам, которые недоступны для автоматического импорта
                  из рекламных площадок (например: рассылки, SEO-трафик), вы
                  можете вносить затраты вручную.`
                    : hasStatistics
                    ? `По тем каналам, которые недоступны для автоматического импорта
                  из рекламных площадок (например: рассылки, SEO-трафик), вы
                  можете вносить затраты вручную.`
                    : `Вы сможете заносить расходы по тем каналам, которые недоступны для автоматического импорта, как только мы начнем получать данные из вашего Google Analytics аккаунта`}
                </Typography>

                {!isFetching ? (
                  <a
                    href={nextUrl}
                    style={{
                      textDecoration: 'none',
                      marginTop: 44,
                      display: 'block',
                    }}
                  >
                    <ButtonOutlined
                      type="button"
                      color="secondary"
                      text="Продолжить"
                    />
                  </a>
                ) : (
                  undefined
                )}
              </section>
            </Wrapper>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(GAAsync)
